export default function UAEAICertificate() {
  return (
    <div className="flex justify-center items-center my-8 md:my-12 lg:my-16 xl:my-20 px-4">
      <div className="w-full max-w-5xl">
        <div className="relative w-full pt-[56.25%]">
          <img
            src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1744050825/UAE/gdsazzylqspvipirca69.png"
            alt="UAE AI Certificate"
            className="absolute top-0 left-0 w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
}
